import config from 'config';

const getEnvTitle = () => {
    switch (config.ENV) {
        case 'prod':
            return (
                <>
                    ⚠️ 𝗪𝗔𝗥𝗡𝗜𝗡𝗚: You are currently in the live 𝗣𝗥𝗢𝗗𝗨𝗖𝗧𝗜𝗢𝗡 environment. All data is real and any changes made here will
                    reflect to the users.
                </>
            );
        case 'stage':
            return <>ℹ️ 𝗪𝗔𝗥𝗡𝗜𝗡𝗚: You are currently in the 𝗦𝗧𝗔𝗚𝗜𝗡𝗚 environment. Changes made here will 𝗡𝗢𝗧 affect live data.</>;
        default:
            return '';
    }
};

const getToolbarBackgroundColor = (): string => {
    switch (config.ENV) {
        case 'stage':
            return '#BBC8FF';
        case 'prod':
            return '#FFE0C2';
        default:
            return '';
    }
};

const shouldShowEnvLabel = config.ENV === 'stage' || config.ENV === 'prod';

const envTitle = getEnvTitle();
const toolbarBackgroundColor = getToolbarBackgroundColor();

const boxStyles = shouldShowEnvLabel
    ? {
          display: 'flex',
          width: '100%',
          justifyContent: 'space-between',
          alignItems: 'center',
          paddingLeft: '2rem',
      }
    : { marginLeft: 'auto' };

export { envTitle, shouldShowEnvLabel, toolbarBackgroundColor, boxStyles };
